/** Responsive outer layout only; section content and dependency decisions remain with their owners. */
import type { ReactNode } from 'react'
import { TestReviewHelp } from '../TestReviewHelp'
import './UnifiedStudySetupPanel.css'

/** With a `bookingUrl`, a separate small help card sits under the summary card; both stay fixed together. */
export function StudyBuilderLayout({
  children,
  summary,
  bookingUrl,
}: {
  children: ReactNode
  summary: ReactNode
  bookingUrl?: string
}) {
  return (
    <s-box paddingBlockEnd="large-500">
      <s-query-container containerName="study-builder">
        <s-grid
          gridTemplateColumns="@container study-builder (inline-size > 900px) 'minmax(0, 1fr) 320px', 'minmax(0, 1fr)'"
          gap="large-200"
          alignItems="start"
        >
          <div className="tf-summary-sticky">
            <s-stack direction="block" gap="base">
              {summary}
              {bookingUrl ? (
                <s-section>
                  <TestReviewHelp variant="compact" bookingUrl={bookingUrl} />
                </s-section>
              ) : null}
            </s-stack>
          </div>
          {children}
        </s-grid>
      </s-query-container>
    </s-box>
  )
}
